// src/utils/request.js

import axios from "axios";
import cookie from "cookie";

const API_ENV = process.env.API_ENV; // dev or production

// 调试：打印环境变量
console.log("[DEBUG] process.env.API_ENV:", process.env.API_ENV);
console.log("[DEBUG] API_ENV constant:", API_ENV);
// 如果你使用像 Element Plus 或 Ant Design Vue 这样的UI库，可以引入它们的 Message 组件用于提示
// import { ElMessage, ElMessageBox } from 'element-plus';

// 假设我们有一个用于管理 token 的模块
// import { getToken, removeToken } from './auth';

// 1. 创建 Axios 实例
const service = axios.create({
    // 根据环境设置 baseURL
    // import.meta.env.VITE_APP_BASE_API 是 Vite 提供的环境变量访问方式
    // baseURL: "https://fdddy.com/server",
    // baseURL: "/easyapi",
    // 请求超时时间（毫秒）
    timeout: 10000,
});

// 2. 请求拦截器 (Request Interceptor)
service.interceptors.request.use(
    (config) => {
        // 在发送请求前做些什么
        console.log("[DEBUG] 请求拦截器 - 完整URL:", config.baseURL ? config.baseURL + config.url : config.url);
        console.log("[DEBUG] 请求拦截器 - config:", config);

        // 可以在这里开启全屏 loading 动画

        // 假设 token 存储在 localStorage 或 Pinia/Vuex 中
        // const token = localStorage.getItem("token"); // 示例：从 localStorage 获取 token
        const token = cookie.parse(document.cookie)["xiaozhi_token"];
        if (token) {
            // 让每个请求携带自定义 token
            // 'Authorization' 是后端约定的请求头字段
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        // 处理跨域请求的凭证
        config.withCredentials = false;

        return config;
    },
    (error) => {
        // 对请求错误做些什么
        console.error("Request Error:", error); // for debug
        return Promise.reject(error);
    }
);

// 3. 响应拦截器 (Response Interceptor)
service.interceptors.response.use(
    /**
     * 如果你想获取诸如 headers 或 status 之类的http信息
     * 请直接 return response
     */

    /**
     * 通过自定义 code 判断请求状态，这里只是一个例子，你也可以根据自己的业务逻辑进行修改
     */
    (response) => {
        // 可以在这里关闭全屏 loading 动画
        console.log("[DEBUG] 响应拦截器 - 请求URL:", response.config.url);
        console.log("[DEBUG] 响应拦截器 - 响应数据:", response.data);

        // 后端返回的数据通常在 response.data 中
        const res = response.data;

        // 处理 token 过期或认证失败的情况
        if (res.code === 401 || res.code === 50008 || res.code === 50012 || res.code === 50014) {
            console.log("[DEBUG] Token expired, API_ENV:", API_ENV);
            // 清除 token
            document.cookie = "course_ok_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
            document.cookie = "course_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
            document.cookie = "xiaozhi_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";

            // 根据环境判断跳转地址
            if (API_ENV === "dev") {
                // 开发环境：跳转到本项目的登录页
                console.log("[DEBUG] Redirecting to /login (dev environment)");
                window.location.href = "/login";
            } else {
                // 生产环境：跳转到 fdddy.com 进行登录
                console.log("[DEBUG] Redirecting to fdddy.com (production environment)");
                window.location.href = "https://fdddy.com/course/#/";
            }
            return Promise.reject(new Error("认证已过期，请重新登录"));
        }

        // 假设与后端约定：code 为 20000 或 0 或 undefined 表示成功
        if (res.code !== 20000 && res.code !== 0 && res.code !== undefined) {
            console.error("Business Error:", res.message || "Error");
            // 将请求判定为失败，进入 catch 块
            return Promise.reject(new Error(res.message || "Error"));
        }

        // 如果 code 正确，则直接返回后端数据中的 data 部分
        return res.data || res;
    },
    (error) => {
        // 可以在这里关闭全屏 loading 动画

        // 处理 HTTP 网络错误
        let message = "";
        const status = error.response ? error.response.status : null;

        switch (status) {
            case 401:
                message = "认证失败，请重新登录";
                // 清除 token 并跳转
                document.cookie = "course_ok_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
                document.cookie = "course_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
                document.cookie = "xiaozhi_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";

                // 根据环境判断跳转地址
                if (API_ENV === "dev") {
                    // 开发环境：跳转到本项目的登录页
                    window.location.href = "/login";
                } else {
                    // 生产环境：跳转到 fdddy.com 进行登录
                    window.location.href = "https://fdddy.com/course/#/";
                }
                break;
            case 403:
                message = "您没有权限访问此资源";
                break;
            case 404:
                message = "请求的资源未找到";
                break;
            case 500:
                message = "服务器内部错误";
                break;
            default:
                // 处理断网的情况
                if (!navigator.onLine) {
                    message = "网络已断开，请检查您的网络连接";
                } else {
                    message = error.message || "请求失败";
                }
        }

        // ElMessage({
        //   message: message,
        //   type: 'error',
        //   duration: 5 * 1000,
        // });
        console.error("HTTP Error:", message);

        return Promise.reject(error);
    }
);

// 4. 导出 Axios 实例
export default service;
